import React, { useState, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/public/Header";
import { isWideRoute } from "../../components/common/u1/measure";
import Footer from "../../components/public/Footer";
import { useDispatch, useSelector } from "react-redux";
import { setUserInfo, clearUserInfo } from "../../store/auth/authSlice";
import { useGetUserQuery } from "../../store/auth/usersApiSlice";
import { Modal, SessionExpired } from "../../components/common";
import { useSessionManager } from "../../Hooks/useSessionManager";
import Login from "./Login";

const RootLayout = ({ liftHeader = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  /* The uplifted public screens keep the bar in view while the page scrolls.
     Scoped to /u1/* so the live screens under this same layout are untouched. */
  const stickyHeader = pathname.startsWith("/u1/");
  /* The bar takes the page's own measure so the logo and the buttons sit on the content's left and right edges rather than 128px inside them. */
  const wideHeader = isWideRoute(pathname);
  const { token } = useSelector((state) => state.auth);
  const { data, refetch, isSuccess, isError, error } = useGetUserQuery(token, {
    skip: !token,
  });
  const [isSessionExpired, setSessionExpired] = useState(false);
  const sessionExpiredPopup = () => {
    setSessionExpired(!isSessionExpired);
    dispatch(clearUserInfo());
    navigate("/login");
  };
  useEffect(() => {
    if (isError) {
      if (error?.data?.code == 'token_not_valid') {
        setSessionExpired(true);
      }
    }
    if (isSuccess) {
      dispatch(setUserInfo({ ...data }));
    }
  }, [data, dispatch, isSuccess, isError]);

  return (
    <>
      {isSessionExpired && <Modal modalHandle={sessionExpiredPopup}>
        <SessionExpired handleNavigate={sessionExpiredPopup} />
      </Modal>}
      <Header liftHeader={liftHeader} sticky={stickyHeader} wide={wideHeader} />
      <Outlet />
      <Footer />
      
    </>
  );
};

export default RootLayout;
